import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CalendarModeGuard  {
  constructor(
    private readonly userPermissionsService: UserPermissionsService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userPermissionsService.calendarPermissions$.pipe(
      map(({ hasCalendarAccess, hasTasksAccess }) => {
        if (!hasCalendarAccess && !hasTasksAccess) {
          return this.router.createUrlTree(['/']);
        }

        const mode = route.paramMap.get('mode') ?? 'occupancy';

        if (mode === 'occupancy' && !hasCalendarAccess) {
          return this.router.createUrlTree(['/calendar/tasks']);
        }

        if (mode === 'tasks' && !hasTasksAccess) {
          return this.router.createUrlTree(['/calendar/occupancy']);
        }

        return true;
      })
    );
  }
}
